var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "modal-form",
    {
      class: _vm.$style.dialog,
      on: { cancel: _vm.$formCancelHandler, submit: _vm.$formSubmitHandler },
    },
    [
      _c(
        "span",
        { attrs: { slot: "header" }, slot: "header" },
        [
          !_vm.user.token
            ? [
                _c("div", { class: _vm.$style.noLink }, [
                  _c("i", { staticClass: "material-icons icon" }, [
                    _vm._v("info_outline"),
                  ]),
                  _c("span", [_vm._v("User has no valid link")]),
                ]),
                !_vm.action
                  ? _c("div", { class: _vm.$style.noLinkText }, [
                      _vm._v(
                        " This user's link has been broken. To generate a new link for this user, click generate new link below. "
                      ),
                    ])
                  : _vm._e(),
              ]
            : _vm._e(),
          _c("div", [
            _vm._v(
              _vm._s(_vm.user.firstName) + " " + _vm._s(_vm.user.lastName)
            ),
          ]),
          _c("div", { class: _vm.$style.subHeader }, [
            _c(
              "div",
              [
                _vm._v(_vm._s(_vm.user.department)),
                _vm.user.department && _vm.user.jobTitle
                  ? [_vm._v(",")]
                  : _vm._e(),
                _vm._v(_vm._s(_vm.user.jobTitle)),
              ],
              2
            ),
            _c("div", [_vm._v(_vm._s(_vm.user.email))]),
            _c("div", [_vm._v(_vm._s(_vm.user.phone))]),
          ]),
        ],
        2
      ),
      _c(
        "div",
        {
          staticClass: "vModalDefaultBody hotel-directory",
          attrs: { slot: "body" },
          slot: "body",
        },
        [
          _vm.user.token
            ? _c(
                "div",
                { class: _vm.$style.group },
                [
                  _c(
                    "rb-input",
                    { staticClass: "rbInputEmpty", class: _vm.$style.link },
                    [
                      _c("i", { staticClass: "material-icons icon" }, [
                        _vm._v("link"),
                      ]),
                      _c("input", {
                        staticClass: "rbInput",
                        attrs: { type: "text", disabled: "" },
                        domProps: { value: _vm.link },
                      }),
                    ]
                  ),
                  _c("span", [
                    _c(
                      "i",
                      {
                        staticClass: "material-icons",
                        class: _vm.$style.copy,
                        on: { click: _vm.copy },
                      },
                      [_vm._v("filter_none")]
                    ),
                    _c(
                      "div",
                      {
                        staticClass: "rbTooltip simple",
                        attrs: { tooltip: "placement:top-start" },
                      },
                      [_vm._v("copy link")]
                    ),
                  ]),
                  _c("span", [
                    _c(
                      "i",
                      {
                        staticClass: "material-icons",
                        class: _vm.$style.copy,
                        on: { click: _vm.refresh },
                      },
                      [_vm._v("autorenew")]
                    ),
                    _c(
                      "div",
                      {
                        staticClass: "rbTooltip simple",
                        attrs: { tooltip: "placement:top-start" },
                      },
                      [_vm._v("generate new link")]
                    ),
                  ]),
                  _c("span", [
                    _c(
                      "i",
                      {
                        staticClass: "material-icons",
                        class: _vm.$style.copy,
                        on: { click: _vm.deactivate },
                      },
                      [_vm._v("link_off")]
                    ),
                    _c(
                      "div",
                      {
                        staticClass: "rbTooltip simple",
                        attrs: { tooltip: "placement:top-start" },
                      },
                      [_vm._v("break link")]
                    ),
                  ]),
                  _vm.copying
                    ? _c("div", { class: _vm.$style.copied }, [
                        _vm._v(" copied "),
                      ])
                    : _vm._e(),
                ],
                1
              )
            : _c(
                "rb-input",
                { staticClass: "rbInputEmpty", class: _vm.$style.link },
                [
                  _c("i", { staticClass: "material-icons icon" }, [
                    _vm._v("link_off"),
                  ]),
                  _c("input", {
                    staticClass: "rbInput",
                    attrs: {
                      type: "text",
                      value: "No Valid Link",
                      disabled: "",
                    },
                  }),
                ]
              ),
          _vm.action && _vm.action !== "deactivate"
            ? [
                _c("div", { class: _vm.$style.group }, [
                  _c("div", { class: _vm.$style.sub }, [
                    _vm._v(" Edit out going message "),
                    _c("span", [
                      _c("i", { staticClass: "material-icons" }, [
                        _vm._v("info"),
                      ]),
                      _c(
                        "div",
                        {
                          staticClass: "rbTooltip simple",
                          attrs: { tooltip: "placement:top-start" },
                        },
                        [
                          _vm._v(
                            " This message wil be included in the email to be sent to the user "
                          ),
                        ]
                      ),
                    ]),
                  ]),
                  _vm.message !== _vm.msg
                    ? _c(
                        "div",
                        { class: _vm.$style.subEnd },
                        [
                          _c("check-box", {
                            attrs: {
                              "check-box-value": true,
                              "check-box-label": "Set as default",
                            },
                            model: {
                              value: _vm.setMessageAsDefault,
                              callback: function ($$v) {
                                _vm.setMessageAsDefault = $$v
                              },
                              expression: "setMessageAsDefault",
                            },
                          }),
                          _c("span", [
                            _c("i", { staticClass: "material-icons" }, [
                              _vm._v("info"),
                            ]),
                            _c(
                              "div",
                              {
                                staticClass: "rbTooltip simple",
                                attrs: { tooltip: "placement:top-start" },
                              },
                              [
                                _vm._v(
                                  " this box will set this message as the default message for future hotel directory emails. "
                                ),
                              ]
                            ),
                          ]),
                        ],
                        1
                      )
                    : _vm._e(),
                ]),
                _c("edit-user-message", {
                  attrs: { "user-account": _vm.userAccount, user: _vm.user },
                  model: {
                    value: _vm.msg,
                    callback: function ($$v) {
                      _vm.msg = $$v
                    },
                    expression: "msg",
                  },
                }),
              ]
            : _vm._e(),
        ],
        2
      ),
      _c(
        "div",
        {
          staticClass: "vModalDefaultFooter",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c(
            "button",
            {
              staticClass: "rbButton",
              attrs: { type: "button" },
              on: {
                click: function ($event) {
                  return _vm.cancel()
                },
              },
            },
            [_vm._v(" Cancel ")]
          ),
          !_vm.action
            ? [
                _vm.user.token && _vm.sendable
                  ? _c(
                      "button",
                      {
                        staticClass: "rbButton",
                        attrs: { type: "button" },
                        on: {
                          click: function ($event) {
                            $event.stopPropagation()
                            $event.preventDefault()
                            return _vm.send.apply(null, arguments)
                          },
                        },
                      },
                      [
                        _c("i", { staticClass: "material-icons" }, [
                          _vm._v("email"),
                        ]),
                        _vm._v(" Send Link "),
                      ]
                    )
                  : !_vm.user.token
                  ? _c(
                      "button",
                      {
                        staticClass: "rbButton",
                        attrs: { type: "button" },
                        on: {
                          click: function ($event) {
                            $event.stopPropagation()
                            $event.preventDefault()
                            return _vm.refresh()
                          },
                        },
                      },
                      [
                        _c("i", { staticClass: "material-icons" }, [
                          _vm._v("autorenew"),
                        ]),
                        _vm._v(" Generate New Link "),
                      ]
                    )
                  : _vm._e(),
              ]
            : _c("button", { staticClass: "rbButton mainButton" }, [
                _c("i", { staticClass: "material-icons" }, [_vm._v("email")]),
                _vm._v(" " + _vm._s(_vm.buttonText) + " "),
              ]),
        ],
        2
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }